import React from 'react';
import { BookPreviewSection } from '../BookPreview';

interface DefaultContentRendererProps {
  currentSection?: BookPreviewSection;
}

export const DefaultContentRenderer: React.FC<DefaultContentRendererProps> = ({ currentSection }) => {
  return (
    <div className="text-center">
      <div className="bg-gray-100 dark:bg-gray-800 rounded-lg p-8 mb-4">
        <div className="text-4xl mb-4">📝</div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
          {currentSection?.title || 'Nội dung'}
        </h3>
        <p className="text-gray-600 dark:text-gray-400">
          Loại: {currentSection?.type || 'Không xác định'}
        </p>
      </div>
    </div>
  );
};
